import {useEffect, useState} from "react";

const DATA_REQUESTED_KEY = 'ebird-data-requested';
const EBIRD_DATA_DOWNLOAD_URL = 'https://ebird.org/downloadMyData';

export function useDataRequest() {
    const [hasRequestedData, setHasRequestedData] = useState(false);
    const [isDataRequestReady, setIsDataRequestReady] = useState(false);

    useEffect(() => {
        setHasRequestedData(Boolean(localStorage.getItem(DATA_REQUESTED_KEY)));
        setIsDataRequestReady(true);
    }, []);

    const openMyDataRequest = () => {
        window.open(EBIRD_DATA_DOWNLOAD_URL);
        localStorage.setItem(DATA_REQUESTED_KEY, 'true');
        setHasRequestedData(true);
    }

    const resetMyDataRequest = () => {
        localStorage.removeItem(DATA_REQUESTED_KEY);
        setHasRequestedData(false);
    }

    return {
        hasRequestedData,
        isDataRequestReady,
        openMyDataRequest,
        resetMyDataRequest
    }
}
